(() => {
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');

  function moneyValue(section, record) {
    return record?.dataset.price || section.querySelector('[data-product-price]')?.textContent || '';
  }

  function initializeProduct(section) {
    if (section.dataset.productReady === 'true') return;
    section.dataset.productReady = 'true';
    const variantsNode = section.querySelector('[data-product-variants]');
    const variants = variantsNode ? JSON.parse(variantsNode.textContent) : [];
    const records = new Map([...section.querySelectorAll('[data-variant-record]')].map(node => [String(node.dataset.id), node]));
    const primaryForm = section.querySelector('[data-product-form]');
    const sticky = section.querySelector('[data-sticky-buy]');
    const controller = new AbortController();
    section.productAbortController = controller;
    const dialog = section.querySelector('[data-product-zoom-dialog]');
    const zoomButtons = [...section.querySelectorAll('[data-product-zoom]')];
    let zoomIndex = 0;

    function showZoom(index) {
      if (!dialog || !zoomButtons.length) return;
      zoomIndex = (index + zoomButtons.length) % zoomButtons.length;
      const source = zoomButtons[zoomIndex];
      const image = dialog.querySelector('[data-product-zoom-image]');
      image.src = source.dataset.zoomSrc;
      image.alt = source.dataset.zoomAlt || '';
      dialog.querySelectorAll('[data-dialog-previous],[data-dialog-next]').forEach(button => { button.hidden = zoomButtons.length < 2; });
      if (!dialog.open) {
        dialog.showModal();
        document.body.classList.add('dialog-open');
      }
    }

    if (dialog) {
      dialog.addEventListener('close', () => document.body.classList.remove('dialog-open'), { signal: controller.signal });
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      }, { signal: controller.signal });
      document.addEventListener('keydown', event => {
        if (!dialog.open || zoomButtons.length < 2) return;
        if (event.key === 'ArrowLeft') { event.preventDefault(); showZoom(zoomIndex - 1); }
        if (event.key === 'ArrowRight') { event.preventDefault(); showZoom(zoomIndex + 1); }
      }, { signal: controller.signal });
    }

    section.querySelectorAll('.product-accordion').forEach(details => {
      const content = details.querySelector('.product-accordion__content');
      let animation;
      let targetOpen = details.open;
      details.querySelector('summary').addEventListener('click', event => {
        event.preventDefault();
        const nextOpen = !targetOpen;
        if (animation) animation.cancel();
        targetOpen = nextOpen;
        details.classList.toggle('is-collapsing', !nextOpen);
        if (reducedMotion.matches) {
          details.open = nextOpen;
          details.classList.remove('is-collapsing');
          return;
        }
        const startHeight = details.open ? content.getBoundingClientRect().height : 0;
        if (nextOpen) details.open = true;
        const endHeight = nextOpen ? content.scrollHeight : 0;
        content.style.overflow = 'hidden';
        animation = content.animate([
          { height: `${startHeight}px`, paddingBottom: startHeight ? '22px' : '0px', opacity: nextOpen ? 0 : 1 },
          { height: `${endHeight}px`, paddingBottom: nextOpen ? '22px' : '0px', opacity: nextOpen ? 1 : 0 }
        ], { duration: 300, easing: 'cubic-bezier(.22,1,.36,1)' });
        animation.onfinish = () => {
          details.open = nextOpen;
          details.classList.remove('is-collapsing');
          content.style.overflow = '';
          animation = null;
        };
      }, { signal: controller.signal });
    });

    function setQuantity(input, value) {
      if (!input) return;
      const parsed = Number.parseInt(value, 10);
      const quantity = Number.isFinite(parsed) ? Math.max(1, parsed) : 1;
      input.value = quantity;
      const minus = input.closest('[data-quantity-control]')?.querySelector('[data-quantity-minus]');
      if (minus) minus.disabled = quantity <= 1;
    }

    function selectMedia(id, behavior = 'smooth') {
      if (!id) return;
      const item = section.querySelector(`[data-media-id="${CSS.escape(String(id))}"]`);
      if (!item) return;
      section.querySelectorAll('[data-media-id]').forEach(media => media.classList.toggle('is-active', media === item));
      section.querySelectorAll('[data-media-target]').forEach(button => button.classList.toggle('is-active', button.dataset.mediaTarget === String(id)));
      if (matchMedia('(max-width: 989px)').matches) item.scrollIntoView({ behavior: reducedMotion.matches ? 'auto' : behavior, block: 'nearest', inline: 'start' });
    }

    function activeOptions() {
      return [...section.querySelectorAll('[data-option-index]')].map(group => group.querySelector('input:checked')?.value);
    }

    function updateVariant() {
      const options = activeOptions();
      const variant = variants.find(item => item.options.every((value, index) => value === options[index]));
      if (!variant) return;
      const record = records.get(String(variant.id));
      const available = record?.dataset.available === 'true';
      section.querySelectorAll('[data-variant-id]').forEach(input => { input.value = variant.id; });
      section.querySelectorAll('[data-product-price],[data-sticky-price]').forEach(node => { node.textContent = moneyValue(section, record); });
      section.querySelectorAll('[data-add-price]').forEach(node => { node.textContent = record?.dataset.addPrice || moneyValue(section, record); });
      const compare = section.querySelector('[data-product-compare]');
      if (compare) { compare.textContent = record?.dataset.compare || ''; compare.hidden = !record?.dataset.compare; }
      section.querySelectorAll('[data-add-to-cart],[data-sticky-add]').forEach(button => { button.disabled = !available; });
      section.querySelectorAll('[data-add-to-cart],[data-sticky-add]').forEach(button => {
        const label = button.querySelector('[data-add-label],[data-sticky-label]');
        if (label) label.textContent = available ? (button.dataset.availableLabel || 'ADD TO BAG') : 'Sold out';
      });
      section.querySelectorAll('[data-option-index]').forEach(group => { const selected = group.querySelector('input:checked'); const output = group.querySelector('[data-selected-option]'); if (selected && output) output.textContent = selected.value; });
      selectMedia(record?.dataset.mediaId);
      const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url);
    }

    section.addEventListener('change', event => {
      if (event.target.matches('[data-option-index] input')) updateVariant();
      if (event.target.matches('[data-quantity-control] input')) setQuantity(event.target, event.target.value);
    });
    section.addEventListener('click', event => {
      const thumb = event.target.closest('[data-media-target]');
      if (thumb) selectMedia(thumb.dataset.mediaTarget);
      const control = event.target.closest('[data-quantity-plus],[data-quantity-minus]');
      if (control) {
        const input = control.closest('[data-quantity-control]').querySelector('input');
        const next = Number.parseInt(input.value || 1, 10) + (control.hasAttribute('data-quantity-plus') ? 1 : -1);
        setQuantity(input, next);
      }
      const zoom = event.target.closest('[data-product-zoom]');
      if (zoom) showZoom(zoomButtons.indexOf(zoom));
      if (event.target.closest('[data-dialog-close]')) dialog?.close();
      if (event.target.closest('[data-dialog-previous]')) showZoom(zoomIndex - 1);
      if (event.target.closest('[data-dialog-next]')) showZoom(zoomIndex + 1);
    });

    section.querySelectorAll('.product-form,.product-sticky-form').forEach(form => {
      form.addEventListener('submit', () => {
        const quantity = form.querySelector('[data-quantity-control] input');
        if (quantity) setQuantity(quantity, quantity.value);
        const status = section.querySelector('[data-product-status]');
        if (status) status.textContent = 'Adding to bag…';
      });
    });

    section.querySelectorAll('[data-quantity-control] input').forEach(input => setQuantity(input, input.value));

    if (sticky && primaryForm) {
      let stickyFrame = 0;
      const updateSticky = () => {
        stickyFrame = 0;
        const shouldShow = primaryForm.getBoundingClientRect().bottom < 0;
        sticky.hidden = false;
        sticky.classList.toggle('is-visible', shouldShow);
      };
      const scheduleSticky = () => {
        if (!stickyFrame) stickyFrame = requestAnimationFrame(updateSticky);
      };
      window.addEventListener('scroll', scheduleSticky, { passive: true, signal: controller.signal });
      window.addEventListener('resize', scheduleSticky, { passive: true, signal: controller.signal });
      updateSticky();
    }

    const track = section.querySelector('[data-product-track]');
    if (track && matchMedia('(max-width: 989px)').matches) {
      let frame = 0;
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          const item = [...track.children].reduce((closest, candidate) => Math.abs(candidate.offsetLeft - track.scrollLeft) < Math.abs(closest.offsetLeft - track.scrollLeft) ? candidate : closest, track.firstElementChild);
          if (item) section.querySelectorAll('[data-media-target]').forEach(button => button.classList.toggle('is-active', button.dataset.mediaTarget === item.dataset.mediaId));
        });
      }, { passive: true });
    }
  }

  function initializeRecommendations(root = document) {
    root.querySelectorAll('product-recommendations[data-url]').forEach(element => {
      if (element.dataset.loaded === 'true') return;
      element.dataset.loaded = 'true';
      fetch(element.dataset.url).then(response => {
        if (!response.ok) throw new Error(`Recommendations request failed: ${response.status}`);
        return response.text();
      }).then(text => {
        const html = new DOMParser().parseFromString(text, 'text/html').querySelector('product-recommendations');
        if (html?.querySelector('.product-recommendations__grid')) {
          element.innerHTML = html.innerHTML;
          element.hidden = false;
        }
      }).catch(() => {});
    });
  }

  function initialize(root = document) {
    root.querySelectorAll('[data-product-section]').forEach(initializeProduct);
    initializeRecommendations(root);
  }
  document.addEventListener('DOMContentLoaded', () => initialize());
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-product-section]').forEach(section => section.productAbortController?.abort()));
})();
